import React, { useState, useEffect } from "react";
import { CgSpinner } from "react-icons/cg";
import {
  savePreviousState,
  validateChangeAtButton,
  validateWith2Array,
} from "../../../../utils/EditChangeValidate";
import { RiArrowDownSLine, RiArrowRightSLine } from "react-icons/ri";

export default function AddEditForm({
  submitForm,
  submitFormLoading,
  cancelForm,
  loadedValues = {},
  form = [],
  component,
  roles,
  userRoles,
}) {
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [prevState, setPrevState] = useState([]);
  const [preRoles, setPreRoles] = useState([]);
  const [allowEdit, setAllowEdit] = useState(!loadedValues);
  const [showRoles, setShowRoles] = useState(!loadedValues);

  useEffect(() => {
    if (loadedValues) {
      setPrevState(savePreviousState(form));
      const roles = userRoles?.map((role) => role.id + "");
      setSelectedRoles(roles);
      setPreRoles(roles);
    } else if (userRoles) {
      const roles = userRoles?.map((role) => role.id + "");
      setSelectedRoles(roles);
      setPreRoles(roles);
    }
  }, []);

  useEffect(() => {
    if (prevState?.length > 0) {
      const valid = validateChangeAtButton(prevState, form);
      const rolesValid = validateWith2Array(preRoles, selectedRoles);
      if ((valid || rolesValid) && selectedRoles.length > 0)
        setAllowEdit((p) => true);
      else setAllowEdit((p) => false);
    }
  }, [form, selectedRoles]);

  const rolesSelectorHandler = (e) => {
    if (selectedRoles.includes(e.target.value)) {
      setSelectedRoles((p) => p.filter((r) => r !== e.target.value));
    } else {
      setSelectedRoles((p) => [...p, e.target.value]);
    }
  };
  return (
    <div className="flex justify-center items-center bg-white dark:bg-dark rounded-md py-5">
      <form
        method="POST"
        onSubmit={(event) => submitForm(event, selectedRoles)}
        className="w-full  flex flex-col items-center justify-center"
      >
        {form.map((elem, index) => (
          <div
            key={index}
            className={`flex flex-col p-2 gap-1 w-full max-w-md ${
              elem.hidden ? "hidden" : ""
            }`}
          >
            <label htmlFor={`addOrEdit-${elem.name}`} className="text-xs ">
              {elem.text}
            </label>
            {elem.type == "textarea" ? (
              <textarea
                name={elem.name}
                id={`addOrEdit-${elem.name}`}
                cols="10"
                rows="4"
                placeholder={`Enter ${elem.text}`}
                required
                className="border-[1px] border-border uppercase dark:bg-dark rounded-md p-1 py-2 text-xs"
                defaultValue={elem.value}
                onChange={(e) => {
                    const errorElem = document.getElementById(
                      `${component}-${elem.columnName}`
                    );
                    errorElem.style.display = "none";
                    elem.update(e.target.value);
                }}
                disabled={elem.disabled ? true : false}
              ></textarea>
            ) : (
              <input
                type={elem.type}
                name={elem.name}
                id={`addOrEdit-${elem.name}`}
                placeholder={`Enter ${elem.text}`}
                required={elem.required}
                className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
                defaultValue={elem.value}
                onChange={(e) => {
                  const errorElem = document.getElementById(
                    `${component}-${elem.columnName}`
                  );
                  errorElem.style.display = "none";
                  elem.update(e.target.value);
                }}
                disabled={elem.disabled ? true : false}
                pattern={elem?.pattern || false}
              />
            )}

            <p
              id={`${component}-${elem.columnName}`}
              className="hidden w-full h-5 bg-red/5 text-red text-xs"
            ></p>
          </div>
        ))}

        <div className="w-full max-w-md m-3">
          <div className="flex justify-between px-5 py-2">
            <div>
              <h2 className="font-semibold">Select roles</h2>
            </div>
            <button
              className="p-1 rounded-md ring-1  ring-gray shadow-xl hover:scale-105 bg-white"
              type="button"
              onClick={() => setShowRoles((p) => !p)}
            >
              {showRoles ? (
                <RiArrowDownSLine size={"1.4rem"} />
              ) : (
                <RiArrowRightSLine size={"1.4rem"} />
              )}
            </button>
          </div>
          {showRoles && (
            <div className="flex flex-col w-full max-w-md p-2">
              {roles.map((role, i) => {
                return (
                  <div key={i} className="form-control w-full max-w-md">
                    <label className="label cursor-pointer">
                      <span className="label-text">{role.name}</span>

                      <input
                        type="checkbox"
                        className="toggle"
                        name={role.name}
                        id={`addOrEdit-${role.name}`}
                        value={role.id}
                        defaultChecked={userRoles.some(
                          (userRole) => userRole.id === role.id
                        )}
                        onChange={(e) => rolesSelectorHandler(e)}
                      />
                    </label>
                  </div>
                );
              })}
            </div>
          )}
          <p
            id={`${component}-roles`}
            className="hidden w-full h-5 bg-red/5 text-red text-xs  max-w-md p-2"
          ></p>
        </div>

        <div className="p-2  w-full max-w-md flex gap-3">
          <button
            className="ring-1 ring-black dark:ring-red w-full text-xs dark:text-white rounded-md py-2 flex justify-center items-center gap-2"
            type="button"
            disabled={submitFormLoading}
            onClick={cancelForm}
          >
            <p>Cancel</p>
          </button>
          {allowEdit ? (
            <button
              className="bg-black dark:bg-red w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
              type="submit"
              disabled={submitFormLoading}
            >
              <p>Submit</p>
              {submitFormLoading && <CgSpinner className="animate-spin" />}
            </button>
          ) : (
            <button
              disabled
              className="bg-gray cursor-not-allowed dark:bg-red w-full text-xs text-white rounded-md py-2 flex justify-center items-center gap-2"
              title="no changes made"
            >
              <p>Submit</p>
            </button>
          )}
        </div>
      </form>
    </div>
  );
}
